export const REQUEST_AIRPORT_ROUTES = 'REQUEST_AIRPORT_ROUTES'
export const RECEIVE_AIRPORT_ROUTES = 'RECEIVE_AIRPORT_ROUTES'

export const requestAirportRoutes = (selectedAirport, routeType, routeId) => {
  return {
    type: REQUEST_AIRPORT_ROUTES,
    data: {
      selectedAirport,
      routeType,
      routeId,
    },
  }
}

export const receiveAirportRoutes = data => {
  return {
    type: RECEIVE_AIRPORT_ROUTES,
    data,
  }
}
